/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  RiskPolicyBypassRequest,
  RiskPolicyBypassRequest$inboundSchema,
} from "./riskpolicybypassrequest.js";

export type ListRiskPolicyBypassRequestsResult = {
  /**
   * Current risk policy bypass request records.
   */
  requests: Array<RiskPolicyBypassRequest>;
};

/** @internal */
export const ListRiskPolicyBypassRequestsResult$inboundSchema: z.ZodMiniType<
  ListRiskPolicyBypassRequestsResult,
  unknown
> = z.object({
  requests: z.array(RiskPolicyBypassRequest$inboundSchema),
});

export function listRiskPolicyBypassRequestsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListRiskPolicyBypassRequestsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      ListRiskPolicyBypassRequestsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListRiskPolicyBypassRequestsResult' from JSON`,
  );
}
